/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-11-07 15:25:04
 * @LastEditTime: 2023-09-08 15:44:17
 * @LastEditors: Please set LastEditors
 * @FilePath: /ops-manager-frontend/src/components/CheckInstall/messages.js
 */
import { defineMessages } from 'react-intl';

const object = {
  title: '部署环境监测和初始化过程中…',
  tip: '此过程大约持续1-10分钟',
  result: '检测完成',
  download: '检测日志下载',
  exitInstall: '退出安装',
  continueInstall: '继续安装',

  checking: '检测中',
  pass: '通过',
  unPass: '不通过',
  altogether: '共',
  checkFailed: '项检测不通过',
  checkWawarn: '项检测有风险',
  retest: '重新检测',
  noPassTitle: '无法满足安装环境最低要求，不能继续安装！',
  warnPassTitle: '发现可能影响正常安装的检查项，请确认后再进行安装',
  continueInstallTip: '请确认已知晓以上检查项的相关风险可以继续安装',
  editConfig: '修改配置',
  errorItemTitle: '不符合最低要求',
  warnItemTitle: '建议调整的内容',
  cause: '原因',
  suggestion: '改进措施',
  confirmKeyInfo: '请确认以下关键信息，然后再进行安装',
  editSuccess: '修改成功',
  waiting: '等待中',
  overtime: '超时',
  logNull: '暂无日志信息',
  risk: '有风险',
  selectFile: '请点击文件路径进行配置修改',
  success: '设置成功',
};

export default defineMessages(object);
